// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"resources_js_Pages_Dashboard_Index_tsx":"037fe777039e34aa","resources_js_Pages_Drafts_Index_tsx":"e65fdec1ecfd2af9","resources_js_Pages_Plans_Create_tsx":"85a86576119d3b5a","resources_js_Pages_Plans_Edit_tsx":"cf6200b0e1cec016","resources_js_Pages_Plans_Index_tsx":"2ef2609b3e1ff2f8"}[chunkId] + "";
};